import { z } from 'zod';
/**
 * Workspace Zod schemas for API validation
 *
 * These schemas validate API request and response payloads for workspace operations.
 * Used by both backend (validation) and frontend (type inference).
 */
/**
 * Workspace member response schema
 *
 * Represents a workspace user as returned by GET /workspace/members.
 * Used for autocomplete / searchable select in domain role assignment UI.
 */
export const workspaceMemberSchema = z.object({
    uuid: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string(),
    isAdmin: z.boolean(),
});
/**
 * List workspace members response schema
 */
export const listWorkspaceMembersResponseSchema = z.object({
    members: z.array(workspaceMemberSchema),
});
//# sourceMappingURL=workspace.js.map